
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container{
  display:block;
  padding-top:var(--spacing-08);
  font-size:var(--body-03-font-size);
}
  @media (min-width: 768px){.container{
    display:grid;
    grid-template-columns:repeat(2, 1fr);
    grid-template-rows:1fr;
    grid-column-gap:9rem;
    grid-row-gap:0px;
    padding-top:var(--spacing-08)
}
  }

.form{
  padding-bottom:var(--spacing-08);
}

@media (min-width: 768px){

.form{
    padding-bottom:0px
}
  }

.map{
  --body-helper-min-font-size:var(--font-size-base);
  font-size:var(--body-01-font-size);
}

slot[name='form']::slotted(div){
  display:grid;
  row-gap:var(--spacing-04);
}
`;